/**
 * PlayLibraryCard - Draggable play card for the library panel
 * Shows play name, formation, personnel, and type indicator
 */

import type { PlayListItem } from '@/api/queries/PlayQueries'
import './document-editor.css'
import React from 'react'

interface PlayLibraryCardProps {
	play: PlayListItem
	onDragStart: () => void
	index: number
}

export function PlayLibraryCard({ play, onDragStart, index }: PlayLibraryCardProps) {
	const handleDragStart = (e: React.DragEvent) => {
		// Set drag data
		e.dataTransfer.setData('application/play-id', play.id.toString())
		e.dataTransfer.effectAllowed = 'copy'

		onDragStart()
	}

	return (
		<div
			className="play-library-card"
			draggable
			onDragStart={handleDragStart}
			style={{
				'--reveal-delay': `${Math.min(index, 20) * 30}ms`,
			} as React.CSSProperties}
		>
			<div className="play-library-card__content">
				<div className="play-library-card__header">
					<span className="play-library-card__name">{play.name}</span>
					{play.play_type && (
						<span
							className="play-library-card__type-indicator"
							data-type={play.play_type}
							title={play.play_type === 'run' ? 'Run' : 'Pass'}
						/>
					)}
				</div>

				<div className="play-library-card__meta">
					{play.formation_id && (
						<span className="play-library-card__tag">
							Formation #{play.formation_id}
						</span>
					)}
					{play.personnel_id && (
						<span className="play-library-card__tag">
							Personnel #{play.personnel_id}
						</span>
					)}
				</div>
			</div>
		</div>
	)
}
